// traceability: requirements: [NFR-008]
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ThemeMode = 'light' | 'dark' | 'system';

interface ThemeState {
  mode: ThemeMode;
  resolved: 'light' | 'dark';
  setMode: (mode: ThemeMode) => void;
  resolveTheme: () => void;
}

function getSystemTheme(): 'light' | 'dark' {
  if (typeof window === 'undefined') return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'system',
      resolved: getSystemTheme(),
      setMode: (mode) => {
        const resolved = mode === 'system' ? getSystemTheme() : mode;
        set({ mode, resolved });
        applyTheme(resolved);
      },
      resolveTheme: () => {
        const { mode } = get();
        const resolved = mode === 'system' ? getSystemTheme() : mode;
        set({ resolved });
        applyTheme(resolved);
      },
    }),
    {
      name: 'tcm-theme',
      partialize: (state) => ({ mode: state.mode }),
      onRehydrateStorage: () => (state) => {
        state?.resolveTheme();
      },
    },
  ),
);

function applyTheme(resolved: 'light' | 'dark') {
  const root = document.documentElement;
  root.classList.toggle('dark', resolved === 'dark');
}
